import React from "react";
import Industries from "../components/industries/industries";

function IndustriesPage() {
  return (
    <>
      <Industries>
        <div className="row">
          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img alt="1" src={"assets/img/industries/1.jpg"} />
            </div>
            <h3>Petro Chemicals </h3>
          </div>
          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img alt="2" src={"assets/img/industries/2.jpg"} />
            </div>
            <h3>Power Generation </h3>
          </div>
          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img alt="3" src={"assets/img/industries/3.jpg"} />
            </div>
            <h3>Automobiles </h3>
          </div>
          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img alt="4" src={"assets/img/industries/4.jpg"} />
            </div>
            <h3>Nuclear </h3>
          </div>
          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img alt="5" src={"assets/img/industries/5.jpg"} />
            </div>
            <h3>Chemicals </h3>
          </div>
          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img alt="6" src={"assets/img/industries/6.jpg"} />
            </div>
            <h3>Oil &amp; Gas</h3>
          </div>
          {/* <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img src={"assets/img/industries/7.jpg"} />
            </div>
            <h3>Fertilizers</h3>
          </div>
          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img src={"assets/img/industries/8.jpg"} />
            </div>
            <h3>Chromatography </h3>
          </div>
          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img src={"assets/img/industries/9.jpg"} />
            </div>
            <h3>Cryogenics</h3>
          </div> */}
          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img alt="7" src={"assets/img/industries/10.jpg"} />
            </div>
            <h3>Ship Building </h3>
          </div>
          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img  alt="8 "src={"assets/img/industries/11.jpg"} />
            </div>
            <h3>Semi Conductors </h3>
          </div>
          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img alt="9" src={"assets/img/industries/12.jpg"} />
            </div>
            <h3>Bio Pharmaceutical</h3>
          </div>
          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img alt="10" src={"assets/img/industries/13.jpg"} />
            </div>
            <h3>Power Plants </h3>
          </div>
          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img alt="11" src={"assets/img/industries/14.jpg"} />
            </div>
            <h3>Process Instrumentation </h3>
          </div>
          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img alt="12" src={"assets/img/industries/15.jpg"} />
            </div>
            <h3>Analytical Instrumentation</h3>
          </div>
          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img alt="13" src={"assets/img/industries/16.jpg"} />
            </div>
            <h3>Orbital Welding System </h3>
          </div>
          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img alt="14" src={"assets/img/industries/17.jpg"} />
            </div>
            <h3>Aerospace &amp; Defense </h3>
          </div>
          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img alt="15" src={"assets/img/industries/18.jpg"} />
            </div>
            <h3>CNG</h3>
          </div>
        </div>
      </Industries>
    </>
  );
}
export default IndustriesPage;
